import { OriginInfo } from "@/types/index";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

export type AirportCountryCode = "UK" | "NL" | "NONE"

export const airportsByCountry: Record<AirportCountryCode, Array<[string, OriginInfo]>> = {
	UK: [
		// We don't use anymore property "name", we use the content translation from ssr (ie planning_airport_LON)
		["LON", { name: "All London Airports" }],
		["LHR", { name: "London Heathrow", parent: "LON" }],
		["LGW", { name: "London Gatwick", parent: "LON" }],
		["STN", { name: "London Stansted", parent: "LON" }],
		["LTN", { name: "London Luton", parent: "LON" }],
		["LCY", { name: "London City", parent: "LON" }],
		["SEN", { name: "London Southend", parent: "LON" }],
		["BRS", { name: "Bristol" }],
		["BHX", { name: "Birmingham" }],
		["MAN", { name: "Manchester" }],
		["LPL", { name: "Liverpool" }],
		["EMA", { name: "East Midlands" }],
		["LBA", { name: "Leeds Bradford" }],
		["NCL", { name: "Newcastle" }],
		["EDI", { name: "Edinburgh" }],
		["GLA", { name: "Glasgow" }],
		["CWL", { name: "Cardiff" }],
		["ABZ", { name: "Aberdeen" }],
		["BFS", { name: "Belfast" }],
		["BOH", { name: "Bournemouth" }],
		["SOU", { name: "Southampton" }],
		["EXT", { name: "Exeter" }],
    	["DUB", { name: "Dublin" }],
		["GCI", { name: "Guernsey" }],
  ],
  NL: [
	["AMS", { name: "Amsterdam Schiphol" }],
	["BRU", { name: "Brussels" }],
	["DUS", { name: "Dusseldorf" }],
  ],
  NONE: [
	  ["None", { name: "NA" }]
  ]
};

export const airportCodeMapByWebsiteDomain: Record<string, Map<string, OriginInfo>> = {
	"www.uk.travelski.com": new Map<string, OriginInfo>([...airportsByCountry.UK, ...airportsByCountry.NONE]),
	"www.nl.travelski.com": new Map<string, OriginInfo>([...airportsByCountry.NL, ...airportsByCountry.NONE]),
	"www.benl.yoonly.eu": new Map<string, OriginInfo>([...airportsByCountry.NL, ...airportsByCountry.NONE]),
}

const country = getSiteFromDomain(window.location.hostname);
export const airportCodeMap = new Map<string, OriginInfo>(airportCodeMapByWebsiteDomain[country]);

// export const airportCodeMap = new Map<string, OriginInfo>(Object.values(airportsByCountry).flat())